import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {
	UpdateNovaAgentAudienceInput,
	UpdateNovaAgentAudienceMutation as UpdateNovaAgentAudienceMutationType,
} from './__generated__/UpdateNovaAgentAudienceMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// The service re-reads the partition with ConsistentRead specifically so this payload is
// authoritative, so the caller uses it directly instead of firing a second read. Keep this selection
// in step with novaDeploymentQuery in NovaStudioPage, which is the shape the Deploy tab reads.
const mutation = graphql`
	mutation UpdateNovaAgentAudienceMutation($input: UpdateNovaAgentAudienceInput!) {
		updateNovaAgentAudience(input: $input) {
			agent {
				id
				deployment {
					isLiveToAnyone
					companyCount
					userCount
					companies {
						companyId
					}
					persons {
						personId
						companyId
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<UpdateNovaAgentAudienceInput>,
	onSuccess?: RelayOnCompleted<UpdateNovaAgentAudienceMutationType>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<UpdateNovaAgentAudienceMutationType>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
